module.exports = __webpack_public_path__ + "Icono_Paciente-Bco_512px.png";